<template>
  <div id="projects-detail-page">
    <!-- <ParallaxHeader :headline="getProjectName" :slogan="projectDetails.location" :headerHeight="'450'"/> -->
    <ParallaxHeader :headline="getProjectName" :slogan="getProjectLocation" :headerHeight="'550'" :headerImg="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + projectDetails[paraIndex].project.parallax_image"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <!-- <v-flex xs12 lg10 xl8> -->
        <v-flex xs12 lg8 xl6>
        <!-- <v-card flat color="grey lighten-2"> -->
          <v-tabs color="grey lighten-2" left>
            <v-tab v-for="tab in tabs" :key="tab.name" @click="showTab(tab.tab)">
              {{ tab.name }}
            </v-tab>
          </v-tabs>
          <!-- <v-container fluid fill-height v-if="tabInfo"> -->
            <v-layout row wrap v-if="tabInfo && projectDetails.length > 0">
              <v-flex xs12 md3>
                <v-card>
                  <v-list class="grey lighten-3 hidden-sm-and-down"> 
                    <v-list-tile v-for="(item, itemIndex) in projectDetails" :key="itemIndex" @click="showDetailsTab(itemIndex, item.id)">
                      <v-list-tile-action>
                        <v-icon v-if="paraIndex === itemIndex">star</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title v-text="item.headline" style="text-transform: uppercase;font-size: 10pt;font-weight: bold;color:#676767;margin-left: -20px;"></v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                  <v-card-text class="hidden-sm-and-down">
                    <div><span style="font-weight: bold;">Gross Realisation</span><p>{{ projectDetails[0].project.gross_realisation }}</p></div>
                    <div><span style="font-weight: bold;">Date</span><p>{{ projectDetails[0].project.completed_on | yearFormat }}</p></div>
                  </v-card-text>
                  <v-card-actions class="hidden-sm-and-down">
                    <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn>
                    <v-btn flat color="orange" icon><v-icon>fa-map-marker</v-icon></v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
              <v-flex xs12 md9>
                <!-- <p class="headline">{{ projectDetails.name }}</p> -->
                <!-- <div v-for="(item, itemIndex) in projectDetails.paragraphs" :key="itemIndex"> -->
                <div>
                  <p class="display-1">{{ projectDetails[paraIndex].headline}} 
                    <div class="hidden-md-and-up">
                      <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn>
                      <v-btn flat color="orange" icon><v-icon>fa-map-marker</v-icon></v-btn>
                      <v-menu offset-y>
                        <v-icon slot="activator">fa-ellipsis-h</v-icon>
                        <v-list class="grey lighten-2"> 
                          <v-list-tile v-for="(item, itemIndex) in projectDetails" :key="itemIndex" @click="showDetailsTab(itemIndex, item.id)">
                            <v-list-tile-action>
                              <v-icon v-if="paraIndex === itemIndex">star</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title v-text="item.headline" style="text-transform: uppercase;font-size: 10pt;font-weight: bold;color:#676767;"></v-list-tile-title>
                          </v-list-tile>
                        </v-list> 
                      </v-menu>
                    </div>
                  </p>
                  <hr class="buzz-hr">
                  <v-card v-if="paraIndex === 0 && projectDetails[paraIndex].project.main_image" flat>
                    <v-card-media
                      :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + projectDetails[paraIndex].project.main_image"
                      height="35vh">
                    </v-card-media>
                  </v-card>
                  <!-- <p v-for="(desc, descIndex) in projectDetails[paraIndex].description" :key="descIndex" class="content-text">{{ desc }}</p> -->
                  <p v-if="!showDetailsGallery" v-for="(para, i) in projectDetails[paraIndex].content.split('\n')" :key="i" class="content-text">{{ para }}</p> 
                  <ImageGallery :thumbnail="detailsGallery" v-else/>
                  <v-spacer></v-spacer>
                </div>
              </v-flex>
            </v-layout>
          <!-- </v-container>  -->
          <!-- <ImageGallery :thumbnail="projectDetails.gallery" v-else/> -->
          <ImageGallery :thumbnail="gallery" v-else/>
        <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ParallaxHeader from '@/components/ParallaxHeader'
import ImageGallery from '@/components/ImageGallery'
import { mapGetters, mapActions } from 'vuex'
import Api from '@/api'

export default {
  data () {
    return {
      tabInfo: true,
      tabGallery: false,
      tabs: [
        {name: 'Info', tab: 'tab-info'},
        {name: 'Gallery', tab: 'tab-gallery'}
      ],
      paraIndex: 0,
      gallery: [],
      imageGallery: [],
      detailsGallery: [],
      showDetailsGallery: false,
      headerImg: ''
    }
  },
  beforeMount () {
    this.updateActiveProjectName(this.$route.path.split('/')[2])
    this.getGalleryData(this.projectID)
    // console.log(this.projectDetails)
  },
  components: {
    ParallaxHeader,
    ImageGallery
  },
  computed: {
    ...mapGetters({
      projectID: 'projects/getActiveProjectID',
      getProjectName: 'projects/getActiveProjectName',
      getProjectLocation: 'projects/getActiveProjectLocation',
      projectDetails: 'projects/getActiveProjectDetails'
    })
  },
  methods: {
    ...mapActions({
      updateActiveProjectName: 'projects/updateActiveProjectName'
    }),
    showTab (tabName) {
      if (tabName === 'tab-info') {
        this.tabInfo = true
        this.tabGallery = false
      } else if (tabName === 'tab-gallery') {
        this.tabInfo = false
        this.tabGallery = true
      }
    },
    getGalleryData (projectID) {
      // console.log(projectID)
      const path = '/image-gallery/' + projectID
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.imagegallery[0].project_details)
            this.imageGallery = response.data.imagegallery
            response.data.imagegallery.forEach((el) => {
              // this.gallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
              this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline })
            })
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    showDetailsTab (itemIndex, detailsID) {
      this.detailsGallery = []
      this.imageGallery.forEach((el) => {
        if (el.project_details.id === detailsID) {
          // this.detailsGallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
          this.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name, 'project_details': el.project_details.headline })
        }
      })
      if (this.detailsGallery.length > 0) {
        this.showDetailsGallery = true
      } else {
        this.showDetailsGallery = false
      }
      this.paraIndex = itemIndex
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
#projects-detail-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.container {
  /*min-height: 58vh;*/
}
</style>


// WEBPACK FOOTER //
// src/pages/ProjectDetailPage.vue